import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import store from 'store';

import Stack from '@mui/material/Stack';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Router from 'Router';
import ThemeProvider from './features/theme/ThemeProvider';
import NotistackProvider from 'features/notification/NotistackProvider';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ThemeProvider>
        <Provider store={store}>
          <Stack minHeight="100vh">
            <Header />
            <Stack component="main" position="relative" flex={1}>
              <NotistackProvider>
                <RouterProvider router={router} />
              </NotistackProvider>
            </Stack>
            <Footer />
          </Stack>
        </Provider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

// 匯出路由器，以方便在不是 Component 內部所以不能使用 useNavigate 等 hooks 的地方，依舊能使用例如轉址的功能。
export const router = createBrowserRouter([
  {
    path: '*',
    element: <Router />,
  },
]);

export default App;
